import { Spin } from 'antd'
import React from 'react'
import styled from 'styled-components'
import Amount from '../Amount'
import { useCurrentInvoice } from './queries'

const DiscountRow = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
`

const DiscountBlock = () => {
  const invoiceQuery = useCurrentInvoice()

  return (
    <Spin
      spinning={invoiceQuery.isLoading}
      style={{
        width: '100%',
        whiteSpace: 'nowrap',
      }}
    >
      <DiscountRow>
        <Amount
          unit={invoiceQuery.data?.unitID ?? ''}
          amount={invoiceQuery.data?.discount?.amount ?? 0}
        />
      </DiscountRow>
    </Spin>
  )
}

export default DiscountBlock
